import { motion } from "framer-motion";

/**
 * Editorial scroll-reveal wrapper. Wraps any block and fades it up on entry.
 * - `once` so revealing doesn't re-trigger while scrolling back
 * - `margin` gives a comfortable trigger point below the viewport edge
 * - `delay` staggers siblings when needed
 */
export const Reveal = ({
  children,
  delay = 0,
  y = 32,
  duration = 0.9,
  className = "",
  as = "div",
  once = true,
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px 0px -80px 0px" }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
};

/**
 * Split a heading string into words and reveal each with a soft mask-y feel.
 * Great for the Awwwards-style on-load moment on hero titles.
 */
export const WordReveal = ({ text, className = "", delay = 0, stagger = 0.06 }) => {
  const words = String(text).split(" ");
  return (
    <span className={className} aria-label={text}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-baseline">
          <motion.span
            className="inline-block will-change-transform"
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{
              duration: 0.9,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
